<div class="row mb-3">
  <div class="col-12 col-md-4 mb-3 mb-md-0">
    <div class="preview rounded-3 overflow-hidden">
      <img
        class="preview-image w-100 h-100"
        alt="preview_image"
        [src]="mainImage.key | signedUrl : mainImage.path | async"
      />
    </div>
  </div>
  <div class="col-6 col-md-auto row">
    <div class="col-12">
      <div class="d-flex flex-wrap gap-1">
        @for( image of clinicImages; track $index) {
        <img
          class="category-image"
          alt="clinic image"
          [src]="image.key | signedUrl : image.path | async"
          (click)="mainImage = image"
        />}
      </div>
    </div>
  </div>
  <div class="col-6 col-md-auto row">
    <div class="col-12">
      <div class="d-flex flex-wrap gap-1">
        @for( image of teamImages; track $index) {
        <img
          class="category-image"
          alt="team image"
          [src]="image.key | signedUrl : image.path | async"
          (click)="mainImage = image"
        />}
      </div>
    </div>
  </div>
</div>
